/**
 * Generates an array of n visually distinct hex/HSL color strings.
 * Evenly distributes hues around the color wheel.
 *
 * @param {number} count - Total number of hardware colors needed.
 * @param {number} [saturation=70] - Color saturation percentage.
 * @param {number} [lightness=45] - Color lightness percentage.
 * @returns {Array<string>} Array of HSL color strings.
 */
export function generateDevicePalette(count, saturation = 70, lightness = 45) {
  if (count <= 0) return [];
  
  const colors = [];
  // Use a golden-ratio or even step interval to separate adjacent colors cleanly
  const step = 360 / count;

  for (let i = 0; i < count; i++) {
    // Starting hue offset (e.g. 140deg for green/teal tones)
    const hue = Math.round((140 + i * step) % 360);
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }

  return colors;
}


export function getLighterColor(colorStr, percent=55) {
  if (colorStr.startsWith('hsl')) {
    const match = colorStr.match(/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/);
    if (match) {
      const [, h, s, l] = match;
      const newL = Math.min(100, Number(l) + percent);
      return `hsl(${h}, ${s}%, ${newL}%)`;
    }
  }
  // Fallback if hex or rgb
  return colorStr;
}
